export const SERVICE_PLACEHOLDER = "—";

export function getServiceValue(...candidates: (string | null | undefined)[]): string {
    return candidates.find((candidate) => candidate?.trim()) ?? SERVICE_PLACEHOLDER;
}
